import { render, staticRenderFns } from "./HandoffSvg.vue?vue&type=template&id=e75b7888"
import script from "./HandoffSvg.vue?vue&type=script&lang=js"
export * from "./HandoffSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports